import initTabs from "../../common/initTabs";
import componentSlider from "../../common/componentSlider.js";

const MEDIUM_BREAKPOINT = 780;

const initTopicFilterSection = (el) => {
  initTabs(el);

  const panels = el.querySelectorAll(".js-topic-filter-section-panel");
  panels.forEach((panel) => {
    // Mobile carousel
    const config = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: MEDIUM_BREAKPOINT,
          settings: "unslick",
        },
      ],
    };

    if (document.dir === "rtl" || el.closest('[dir="rtl"]')) {
      config.rtl = true;
      el.dataset.isRtl = "true";
    }

    let activeSlider = window.innerWidth <= MEDIUM_BREAKPOINT;

    const sliderControls = componentSlider(panel, config);

    window.addEventListener("resize", () => {
      if (!activeSlider && window.innerWidth <= MEDIUM_BREAKPOINT) {
        activeSlider = true;
        sliderControls.createSlider();
      }

      if (activeSlider && window.innerWidth > MEDIUM_BREAKPOINT) {
        activeSlider = false;
      }
    });
  });
};

export default () => {
  document.querySelectorAll(".js-topic-filter-section").forEach((el) => {
    if (document.body.classList.contains("is-page-editor")) return;

    initTopicFilterSection(el);
  });
};
